$(document).ready(function(){
  $('.custom-homegrid .section a.media-grid__item.shadow.group:first-child, .custom-homegrid .section a.media-grid__item.shadow.group:nth-child(2), .custom-homegrid .section a.media-grid__item.shadow.group:nth-child(3)').wrapAll('<div class="cover-colla"></div>');
  $('.cover-colla a.media-grid__item.shadow.group:nth-child(2), .cover-colla a.media-grid__item.shadow.group:nth-child(3)').wrapAll('<div class="cover-colla-oth"></div>');
  $('.cover-colla > a.media-grid__item.shadow.group').addClass('cob-nob');
  $('.icon-txt-img').wrapAll('<div class="parent-icnimg-oth"></div>');
  $('.product-info__accordion').wrapAll('<div class="producrt-parent-desc"></div>');
  $('.get-temp-product .section.section-blends.section-full').addClass('reviews-product');
  $(".pop-open").on("click", function() {
  $(".popup-overlay, .popup-content").addClass("pop-active");
  $('body').addClass('pop-open');
  });
  $(".pop-close, .popup-overlay").on("click", function() {
  $(".popup-overlay, .popup-content").removeClass("pop-active");
  $('body').removeClass('pop-open');
  });
  if($(window).width() < 767){
            $('.footer__block p.bold').click(function(){
             $(this).next('.toggle_content').slideToggle('slow');
             $(this).toggleClass('active');
           });
          $('.footer__block.footer__block--newsletter p.h5.bold').removeClass('h5');
  }
  $(".custom-view-more").prev('section').hide();
  $('button.view-btn').on('click',function(){
    $( this ).fadeIn( "slow", function() {
          $('.custom-view-more').hide();
          $('.custom-view-more').prev('section').show();
    });
  });
});